import dateHelper from '../helpers/DateHelper';
export default class VehicleRequestController {
  constructor(resource) {
    this._resource = resource;
  }

  createVehicleRequestWithoutPayment(data) {
    return this._resource(`vehicleRequest/create`)
      .save(data)
      .then(res => res.body)
      .catch(error => {
        throw error;
      });
  }

  async create(vehicleRequest) {
    let result;
    try {
      let response = await this._resource('vehicleRequest').save(
        vehicleRequest
      );
      result = {
        ok: response.ok,
        message: response.body.message,
        request: response.body.request,
      };
    } catch (error) {
      throw (result = {
        ok: false,
        message: error.body.message,
      });
    }
    return result;
  }

  async createByAdm(vehicleRequest) {
    let result;
    try {
      let response = await this._resource('vehicleRequest-by-adm').save(
        vehicleRequest
      );
      result = {
        ok: response.ok,
        message: response.body.message,
        request: response.body.request,
      };
    } catch (error) {
      throw (result = {
        ok: false,
        message: error.body.message,
      });
    }
    return result;
  }

  async createFreeByAdm(vehicleRequest) {
    return this._resource('vehicleRequest/create-by-adm')
      .save(vehicleRequest)
      .then(
        res => res.json(),
        error => {
          throw new Error(error.body.message);
        }
      );
  }

  async update(vehicleRequest) {
    let result;
    try {
      let response = await this._resource(
        `vehicleRequest/driver/${vehicleRequest.id}`
      ).update(vehicleRequest);
      result = {
        ok: response.ok,
        message: response.body.message,
      };
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  async updateVehicle(vehicleRequestId, newVehicleId) {
    let result;
    try {
      let response = await this._resource(
        `vehicle-requests/update-vehicle/${vehicleRequestId}/${newVehicleId}`
      ).update();

      result = {
        ok: response.ok,
        message: response.body.message,
      };
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  async getPromotionsByClient(begin_date = null, end_date = null) {
    try {
      let response;
      if (end_date)
        response = await this._resource(
          `vehicleRequest/promotionsByClient?begin_date=${begin_date}&end_date=${end_date}`
        ).get();
      else if (begin_date)
        response = await this._resource(
          `vehicleRequest/promotionsByClient?begin_date=${begin_date}`
        ).get();
      else
        response = await this._resource(
          `vehicleRequest/promotionsByClient`
        ).get();

      return response.body;
    } catch (error) {
      return {
        ok: false,
        message: error.body.message,
      };
    }
  }

  async getVehicleRequestsWithPromotionByClientId(
    client_id,
    begin_date = null,
    end_date = null
  ) {
    try {
      let response;
      if (end_date)
        response = await this._resource(
          `vehicleRequest/withPromotionByClientId/${client_id}?begin_date=${begin_date}&end_date=${end_date}`
        ).get();
      else if (begin_date)
        response = await this._resource(
          `vehicleRequest/withPromotionByClientId/${client_id}?begin_date=${begin_date}`
        ).get();
      else
        response = await this._resource(
          `vehicleRequest/withPromotionByClientId/${client_id}`
        ).get();

      return response.body;
    } catch (error) {
      return {
        ok: false,
        message: error.body.message,
      };
    }
  }

  async getVehicleRequestByStep(step_id) {
    try {
      let response = await this._resource(
        `vehicleRequest/step/${step_id}`
      ).get();
      return response.body;
    } catch (error) {
      return {
        ok: false,
        message: error.body.message,
      };
    }
  }

  async getReservationReason(step_id) {
    try {
      let response = await this._resource(`reservation-reason`).get();
      return response.body;
    } catch (error) {
      return {
        ok: false,
        message: error.body.message,
      };
    }
  }

  async getReservationReport(beginDate, endDate, typeClient, clientId = null) {
    return this._resource('reports/reservation').get({
      datas: { beginDate, endDate },
      typeClient: typeClient,
      clientId: clientId,
    });
  }

  async getMaxCancelDate(vehicle_request_id) {
    try {
      const response = await this._resource(
        `vehicle-request/cancelation-limit/${vehicle_request_id}`
      ).get();

      return response.body;
    } catch (error) {
      return {
        ok: false,
        message: error.body.message,
      };
    }
  }

  async getEngagementReport(beginDate) {
    try {
      let response = await this._resource('reports/engagement').get({
        datas: beginDate,
      });
      return response;
    } catch (error) {
      return {
        ok: false,
        message: error.body.message,
      };
    }
  }

  async getDetailedEngagementReport(beginDate) {
    try {
      let response = await this._resource('reports/detailed-engagement').get({
        date: beginDate,
      });
      return response;
    } catch (error) {
      return {
        ok: false,
        message: error.body.message,
      };
    }
  }

  async getReservationsInProgress(page) {
    try {
      let response = await this._resource(
        `vehicle-request/requests-in-progress`
      ).get();
      return response.json();
    } catch (error) {
      return {
        message: 'Não foi possível buscar as reservas atuais!',
      };
    }
  }

  async getById(id) {
    let response = await this._resource(`vehicleRequest/${id}`).get();
    return response.json();
  }

  async getByCouponId(id) {
    let response = await this._resource(`vehicleRequest/coupon/${id}`).get();
    return response.json();
  }

  async getVehicleRequestToManagement() {
    let result;
    try {
      let response = await this._resource(`vehicle-request-management`).get();
      result = response.body;
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  async approveVehicleRequest(id) {
    let result;
    try {
      let response = await this._resource(
        `vehicleRequest/${id}/managerapproved`
      ).save();

      result = {
        ok: response.ok,
        message: response.body.message,
      };
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  async repprovedVehicleRequest(id, motive) {
    let result;
    try {
      let response = await this._resource(
        `vehicleRequest/${id}/managerrepproved`
      ).save({ motive: motive });
      result = {
        ok: response.ok,
        message: response.body.message,
      };
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  async cancelVehicleRequest(id, motive, vehicle_update = undefined) {
    let result;
    try {
      let response = await this._resource(`vehicleRequest/cancel/${id}`).save({
        motive,
        vehicle_update,
      });
      result = {
        ok: response.ok,
        message: response.body.message,
      };
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  async getVehicleRequestReportMonth(month) {
    let result;
    try {
      let response = await this._resource(`vehicle-request/report`).get({
        month: month,
      });

      result = {
        ok: response.ok,
        response: response.body,
      };
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  async getVehicleRequestForOtimizationByStep(step_code, date) {
    let result;
    try {
      let response = await this._resource(
        `vehicle-requests/otimizations/step/${step_code}/${date}`
      ).get();

      response.body.map(i => {
        (i.begin_date = moment(i.begin_date).format('DD[/]MM[/]YYYY HH:mm')),
          (i.end_date = moment(i.end_date).format('DD[/]MM[/]YYYY HH:mm'));
      });

      result = {
        ok: response.ok,
        response: response.body,
      };
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  async finishVehicleRequest(vehicle_request_id) {
    let result;
    try {
      let response = await this._resource(
        `vehicle-requests/finish/${vehicle_request_id}`
      ).update();
      result = {
        ok: response.ok,
        message: response.body.message,
      };
    } catch (error) {
      result = {
        ok: false,
        message: error.message,
      };
    }
    return result;
  }

  async getRefusedVehicleRequests(vehicle_request_id) {
    let response = await this._resource(
      `vehicle-requests/refused/${vehicle_request_id}`
    ).get();

    return response.json();
  }

  async getCompletedVehicleRequests(vehicle_request_id) {
    let response = await this._resource(
      `vehicle-requests/completed/${vehicle_request_id}`
    ).get();

    return response.json();
  }

  async getVehicleRequestByClientId(client_id) {
    let response = await this._resource(
      `vehicleRequest/client/${client_id}`
    ).get();

    return response.json();
  }

  async getVehicleRequestByClientId(client_id) {
    let response = await this._resource(
      `vehicleRequest/client/${client_id}`
    ).get();

    return response.json();
  }

  async getVehicleRequestByUserId(page, limit) {
    let response = await this._resource(`vehicle-request/by-user`).get({
      page,
      limit,
    });
    return response.json();
  }

  async getVehicleRequestsByVehicleId(vehicle_id) {
    let response = await this._resource(
      `vehicle-requests/vehicle/${vehicle_id}`
    ).get();
    return response.json();
  }

  async getVehicleRequestReport() {
    let response = await this._resource(
      `vehicle-requests/report-request`
    ).get();

    return response.json();
  }

  async refundPayment(
    transaction_id,
    observation,
    clientId,
    chagebackValue,
    status,
    password,
    type
  ) {
    let response = await this._resource(
      `vehicle-requests/payments-refund/${transaction_id}`
    ).save({
      observation,
      clientId,
      chagebackValue,
      status,
      password,
      type,
    });
    return response;
  }

  async getPricePrewiew(
    beginDate,
    endDate,
    vehicleId,
    beginOdometer,
    endOdometer,
    endDateReal
  ) {
    let response = this._resource(
      `vehicle-requests/step/check-out/price-preview`
    ).save({
      begin_date: beginDate,
      end_date: endDate,
      vehicle_id: vehicleId,
      beginOdometer: beginOdometer,
      endOdometer: endOdometer,
      end_date_real: endDateReal,
    });

    return response;
  }

  getPricePrewiewForCreateVehicleRequest(body) {
    return this._resource(`vehicle-requests/step/check-in/price-preview`)
      .save(body)
      .then(res => res.body)
      .catch(error => {
        throw error;
      });
  }

  getPricePreview(vehicleRequest) {
    return this._resource(`vehicle-requests/price-preview`)
      .get(vehicleRequest)
      .then(res => res.body)
      .catch(error => {
        throw error;
      });
  }

  async validateCoupon(coupon_cod) {
    let response = await this._resource(`validade-coupon/${coupon_cod}`).get();
    return response;
  }

  async getVehicleRequestById(data) {
    let response = await this._resource(`vehicle-requests/${data}/step`).get();
    return response;
  }

  async getAllVehicleRequest() {
    return await this._resource(`vehicleRequest`).get();
  }

  getTodayRequests(date) {
    return this._resource(`vehicleRequest/report/today-reservation/${date}`)
      .get()
      .then(res => {
        return res;
      })
      .catch(e => {
        throw e;
      });
  }

  sendRelatorioCheckout(vehicleRequestId) {
    return this._resource(`vehicle-request/relatorio-checkout`)
      .save({ vehicleRequestId })
      .then(res => {
        return res;
      })
      .catch(e => {
        throw e;
      });
  }

  cancelByAdm(vehicleRequestId, motivo, estorno, password) {
    return this._resource(
      `vehicleRequest/cancelByAdm/${vehicleRequestId}`
    ).save({
      motive: motivo,
      estorno: estorno,
      password,
    });
  }

  updateCheckInDateByAdm(vehicleRequestId, beginDate) {
    return this._resource(`vehicle-request/byAdm`).update({
      vehicleRequestId: vehicleRequestId,
      newBeginDate: beginDate,
    });
  }

  async updateInsuranceTax(vehicleRequestId, creditCardId, installments) {
    try {
      let response = await this._resource(
        `vehicle-requests/update-insurance`
      ).update({
        vehicleRequestId: vehicleRequestId,
        creditCardId: creditCardId,
        installments: installments,
      });
      return response.body;
    } catch (error) {
      return {
        ok: false,
        message: error.body.message,
      };
    }
  }

  async getVehicleRequestFormFields(vehicleRequestId) {
    try {
      let response = await this._resource(
        `vehicle-requests/form-fields/${vehicleRequestId}`
      ).get();
      return response.body;
    } catch (error) {
      return {
        ok: false,
        message: error.body.message,
      };
    }
  }

  getVehicleRequestStep(vehicleRequestId) {
    return this._resource(`vehicle-requests/step/${vehicleRequestId}`)
      .get()
      .then(res => {
        return res.body;
      })
      .catch(e => {
        throw e;
      });
  }
  getVehicleRoute(vehicleId, beginDate, endDate) {
    return this._resource(`vehicle/getInfosVehicle/between-dates/${vehicleId}`)
      .get({
        data_inicial: beginDate,
        data_final: endDate,
      })
      .then(res => {
        return res;
      })
      .catch(error => {
        throw error;
      });
  }
  getTravelReportByVehicleRequestId(vehicleRequestId) {
    return this._resource(`vehicleRequest/travel-report/${vehicleRequestId}`)
      .get()
      .then(res => {
        return res.body;
      })
      .catch(e => {
        throw e;
      });
  }
  async getCheckonwithreserve(){
    try {
      let response = await this._resource(
        `/vehicle/checkonwithreserve`
      ).get();
      return response.body;
    } catch (error) {
      return {
        ok: false,
        message: error.body.message,
      };
    }
  }
}
